import { Component } from '@angular/core';
import { Router } from '@angular/router';

/**
 * ChangeSuccess component.
 * Displays a success message after a password change and handles navigation back to the login page.
 */
@Component({
  selector: 'app-change-success',
  standalone: true,
  imports: [],
  templateUrl: './change-success.html',
  styleUrl: './change-success.scss'
})
export class ChangeSuccess {
  /**
   * Constructs the ChangeSuccess component.
   * 
   * @param router Angular Router for navigation
   */
  constructor(
    private router: Router,
  ) { }

  /**
   * Handles the submit action and navigates to the login page.
   */
  onSubmit() {
    this.router.navigate(['login']);
  }
}